import axios from "axios";
import { CONSTS } from "src/consts/consts";

const mainUrl =process.env.REACT_APP_MAIN_URL;
const url =mainUrl +CONSTS.MANAGEMENT_GET_METEDATA_VALUES; 
const urlStrings =mainUrl +CONSTS.MANAGEMENT_GET_STRINGS_VALUES; 
//const userLanguage =  localStorage.getItem('language');
export const ManagementService = {
    GET_METEDATA_VALUES :  (metadataGroup) =>  { return  axios(url +`?metadataGroup=${metadataGroup}`)},
    GET_STRINGS_VALUES :  (stringGroup) =>  { return  axios(urlStrings +`?stringGroup=${stringGroup}`)},
};
 